import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import './styles.scss'

@observer
class HeaderMarketing extends React.Component {
  @observable headerDataFromGit = {}
  constructor(props, context) {
    super(props)
    this.getDataFromSource()
  }

  componentDidUpdate(prevProps) {
    if (prevProps?.marketingData != this.props?.marketingData) {
      this.getDataFromSource()
    }
  }

  getDataFromSource = async () => {
    this.headerDataFromGit =
      this.props?.marketingData?.top_bar_marketing_statements_carousel || {}
  }

  render() {
    const { url = '', title = '' } = this.headerDataFromGit?.[0] || {}
    // currently we have only one entry ( design is also static for one entry )
    // to be made dynamic in later designs
    if (!title) {
      return null
    }

    return (
      <div className="top-header-banner">
        <a href={url} target="_blank" rel="noopener noreferrer">
          <span>{title}</span>
        </a>
      </div>
    )
  }
}

export { HeaderMarketing }
export default HeaderMarketing
